<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Quotes</h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
        <label class="block text-gray-700">Trashed:</label>
        <select v-model="form.trashed" class="mt-1 w-full form-select">
          <option :value="null" />
          <option value="with">With Trashed</option>
          <option value="only">Only Trashed</option>
        </select>
      </search-filter>
      <inertia-link class="btn-indigo" :href="route('quotes.create')">
        <span>Add</span>
        <span class="hidden md:inline">Quote</span>
      </inertia-link>
    </div>

    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">ID</th>
          <th class="px-6 pt-6 pb-4">Quote</th>
          <th class="px-6 pt-6 pb-4">Game</th>
          <th class="px-6 pt-6 pb-4">Contributor</th>
          <th class="px-6 pt-6 pb-4">Added</th>
        </tr>
        <tr v-for="quote in quotes.data" :key="quote.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('quotes.edit', quote.id)" tabindex="-1">
              {{ quote.id }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-2 flex items-center" :href="route('quotes.edit', quote.id)" tabindex="-1">
              <index-preview :preview_message='truncate(quote.quote_text)' />
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('quotes.edit', quote.id)" tabindex="-1">
              {{ quote.game || '-' }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('quotes.edit', quote.id)" tabindex="-1">
              {{ quote.contributor || '-' }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('quotes.edit', quote.id)" tabindex="-1">
              {{ quote.added_at ? formatYear(quote.added_at) : '-' }}
            </inertia-link>
          </td>
          <td class="border-t w-px">
            <inertia-link class="px-4 flex items-center" :href="route('quotes.edit', quote.id)" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </inertia-link>
          </td>
        </tr>
        <tr v-if="quotes.data.length === 0">
          <td class="border-t px-6 py-4" colspan="7">No quotes found.</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="quotes.links" />
  </div>
</template>

<script>
import IndexPreview from '../../Shared/IndexPreview.vue'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import Layout from '@/Shared/Layout'

export default {
  metaInfo: { title: 'Quotes' },
  components: {
    IndexPreview,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    quotes: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: function() {
        this.$inertia.get(this.route('quotes'), this.form, { preserveState: true })
      },
    },
  },
  methods: {
    reset() {
      this.form = { search: null, trashed: null }
    },
    truncate(data) {
      return data.split(" ").slice(0, 30).join(" ") + (data.split(" ").length > 30 ? " (...)" : "")
    },
    formatYear(date) {
      if (!date) return '-'
      const match = String(date).match(/(\d{4})/)
      if (match) return match[1]
      const d = new Date(date)
      return Number.isNaN(d.getFullYear()) ? '-' : d.getFullYear()
    },
  },
}
</script>
